// utils
import { formatUnit } from '../../modules/units-formatter';
import { getStatsFormatting } from './../invitee/invitee.utils';
// types
import { IDataFormat, IFRConversionRules } from '@sitegen/common/classes/friends-referral-api';
import { IRuleStatus } from './invitation.types';

export const getRulesStatuses = (
    rules: IFRConversionRules[],
    dataFormat?: IDataFormat[]): IRuleStatus[] => {
    return rules.map(rule => {
        const statsFormatting = getStatsFormatting(rule, dataFormat);
        const formattedParamTreshold = formatUnit(rule.paramThreshold, statsFormatting);
        return {
            paramThreshold: formattedParamTreshold,
            id: rule.id
        };
    });
};
